(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/cart-item-remove
 * -----------------------------------------------------------------------------
 * @version 0.0.2
 * @overview Update a cart-item's quantity to zero.
 * @copyright 2022 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @requires @cam/cart-item
 * -----------------------------------------------------------------------------
*/ if (customElements.get("cart-item-remove") === undefined) {
    class CartItemRemove extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.cartItem = this.closest("cart-item");
            if (!this.cartItem) return;
            this.addEventListener("click", this.updateEvent.bind(this), false);
        }
        updateEvent(event) {
            event.preventDefault();
            this.cartItem.updateQuantity(0);
        }
    }
    customElements.define("cart-item-remove", CartItemRemove);
}



})();
